import { useParams } from 'react-router';
import axios from 'axios';
import { useEffect, useState } from 'react';
import Navigation from '../../components/Navigation';
import CaseSlider from '../../components/case/CaseSlider';
import CaseBoxes from '../../components/case/CaseBoxes';
import Brands from '../../components/Brands';
import TeamSlider from '../../components/team/TeamSlider';
import Footer from '../../components/Footer';
import useApiUrl from '../../framework/hooks/useApiUrlHook';

export default function TeamDetail({ page }) {
    const apiUrl = useApiUrl();
    const { name } = useParams();
    const [member, setMember] = useState([]);

    const getMember = () => {
        axios
            .post(`${apiUrl}/team/detail`, { name })
            .then((response) => {
                setMember(response.data);
            })
            .catch((err) => {
                window.location.replace('/medemerkers');
            });
    };

    useEffect(() => {
        if (apiUrl != null) getMember();
    }, [apiUrl]);

    return (
        <>
            <Navigation />
            <div className="e-hero-area">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-xl-7">
                            <div
                                className="e-hero-content"
                                data-aos="fade-up"
                                data-aos-duration={1000}
                            >
                                <h2>
                                    Hallo, <br />
                                    ik ben {member.voornaam}
                                </h2>
                                <h3>{member.functie}</h3>
                                <p>{member.inleiding_kort}</p>

                                <div className="read-more text-uppercase">
                                    <a href={`mailto:${member.email ? member.email : 'info@bandwerk.nl'}`}>
                                        MAIL {member.voornaam}
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-5 mt-lg-50 mt-md-50 mt-xs-50">
                            <div
                                className="e-hero-thumb"
                                data-aos="fade-up"
                                data-aos-duration={1000}
                            >
                                <img
                                    src={`${apiUrl}/img/extern/ratio/www.bandwerk.nl/medewerkers/orig/1609/1813/100/${member.image}`}
                                    alt="thumb"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <a href="#" className="scroll-down">
                    <span>SCROLL</span>
                    <img src="/assets/img/icons/arrow-down-t.svg" alt="icon" />
                </a>
                <div className="shape">
                    <img src="/assets/img/shape/shape-4.svg" alt="shape" />
                </div>
            </div>
            <div className="e-about-section pt-120 pb-150 pt-lg-40 pb-lg-60  pt-md-40 pb-md-60  pt-xs-40 pb-xs-60">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-7">
                            <div
                                className="e-about-text"
                                data-aos="fade-up"
                                data-aos-duration={1000}
                                dangerouslySetInnerHTML={{ __html: member.inleiding }}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="e-feature-wrap pt-60 pb-130">
                <div className="container">
                    <CaseBoxes cases={member.projecten} />
                    <div className="row mt-80 justify-content-end">
                        <div className="col-xl-7">
                            <div
                                className="ef-content"
                                data-aos="fade-up"
                                data-aos-duration={1000}
                                dangerouslySetInnerHTML={{ __html: member.tekst }}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
}
